export default __webpack_public_path__ + "static/1547-491a2888018d09b1eb3ce93f57ebef5b.gif";